import(/* webpackMode: "eager" */ "/tmp/8def86a95d1d9d9/components/ui/Container.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8def86a95d1d9d9/components/ui/Section.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8def86a95d1d9d9/components/ui/Heading.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8def86a95d1d9d9/components/ui/Text.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8def86a95d1d9d9/components/pages/LegalPage.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8def86a95d1d9d9/node_modules/next/dist/client/link.js");
